import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import GroupCompaniesBanner from '../components/GroupCompaniesBanner';
import SeoIntro from '../components/SeoIntro';
import AboutSection from '../components/AboutSection';
import BusinessSection from '../components/BusinessSection';
import NetworkSection from '../components/NetworkSection';
import InvestmentsSection from '../components/InvestmentsSection';
import TimelineSection from '../components/TimelineSection';
import JournalSection from '../components/JournalSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <GroupCompaniesBanner />
      <SeoIntro />
      <AboutSection />
      <BusinessSection />
      <NetworkSection />
      <InvestmentsSection />
      <TimelineSection />
      <JournalSection />
      <ContactSection />
      <Footer />
    </>
  );
}
